function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// FiltersBar.jsx
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { SortMenu } from "../dropdowns/menus";
const SORT_OPTIONS = [{
  value: "name|ASC",
  label: "Name. A-Z"
}, {
  value: "name|DESC",
  label: "Name. Z-A"
}, {
  value: "sku|ASC",
  label: "Style Number. A-Z"
}, {
  value: "sku|DESC",
  label: "Style Number. Z-A"
}, {
  value: "priceValue|ASC",
  label: "Price. Low to High"
}, {
  value: "priceValue|DESC",
  label: "Price. High to Low"
}];
class SortBar extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleValue", (group, value) => {
      /*this.setState((prev) => {
          const current = prev[group] || [];
          const exists = current.indexOf(value) !== -1;
           const updatedGroup = exists
              ? current.filter((v) => v !== value)
              : current.concat(value);
           const nextState = {
              ...prev,
              [group]: updatedGroup,
          };
           if (typeof this.props.onSortChange === "function") {
              // pass the full filters object up to the parent
              this.props.onSortChange(nextState);
          }
           return nextState;
      });*/
      this.setState({
        sortBy: value
      }, () => {
        if (typeof this.props.onSortChange === "function") {
          this.props.onSortChange(value);
        }
      });
    });
    _defineProperty(this, "clearGroup", group => {
      this.setState(prev => ({
        ...prev,
        [group]: []
      }));
    });
    _defineProperty(this, "clearAll", () => {
      this.setState({
        features: [],
        // array of values
        quick: [],
        collections: [],
        products: [],
        widths: [],
        heights: [],
        depths: [],
        armHeights: []
      }, () => {
        this.props.onFiltersChange(this.state);
      });
    });
    this.state = {
      sortBy: null
    };
  }
  getSelectedItems() {
    const {
      sortBy
    } = this.state;
    const chips = [];
    SORT_OPTIONS.forEach(opt => {
      if (sortBy === opt.value) {
        chips.push({
          id: `features:${opt.value}`,
          group: "features",
          value: opt.value,
          label: `Features: ${opt.label}`
        });
      }
    });
    return chips;
  }
  render() {
    const {
      sortBy
    } = this.state;
    //const chips = this.getSelectedItems();
    let state = this.state;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "sort-bar"
    }, /*#__PURE__*/React.createElement(FilterDropdown, {
      label: "Sort By"
    }, ({
      close
    }) => /*#__PURE__*/React.createElement(SortMenu, {
      options: SORT_OPTIONS,
      selectedValues: [sortBy],
      onToggle: value => this.toggleValue("sortBy", value)
    }))));
  }
}
export default SortBar;